// extracted by mini-css-extract-plugin
module.exports = {"container":"MetricContainer_container__KoZhO","metricContainer":"MetricContainer_metricContainer__1pCot","arrowButton":"MetricContainer_arrowButton__xhTwF"};